import * as type from "../../types/API/productionProcess";
import { IAction } from "../userMetadataReducer";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const createProductionProcessReducer = (
  state = initialState,
  action: IAction
) => {
  switch (action.type) {
    case type.CREATE_PRODUCTION_PROCESS:
      return {
        ...state,
        loading: true,
      };
    case type.CREATE_PRODUCTION_PROCESS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData,
      };
    case type.CREATE_PRODUCTION_PROCESS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const getProductionProcessReducer = (
  state = initialState,
  action: IAction
) => {
  switch (action.type) {
    case type.GET_PRODUCTION_PROCESS:
      return {
        ...state,
        loading: true,
      };
    case type.GET_PRODUCTION_PROCESS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData,
      };
    case type.GET_PRODUCTION_PROCESS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const getProductionProcessByIdReducer = (
  state = initialState,
  action: IAction
) => {
  switch (action.type) {
    case type.GET_PRODUCTION_PROCESS_BY_ID:
      return {
        ...state,
        loading: true,
      };
    case type.GET_PRODUCTION_PROCESS_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData,
      };
    case type.GET_PRODUCTION_PROCESS_BY_ID_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const updateProductionProcessReducer = (
  state = initialState,
  action: IAction
) => {
  switch (action.type) {
    case type.UPDATE_PRODUCTION_PROCESS:
      return {
        ...state,
        loading: true,
      };
    case type.UPDATE_PRODUCTION_PROCESS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData,
      };
    case type.UPDATE_PRODUCTION_PROCESS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};


export const deleteProductionProcessReducer = (
  state = initialState,
  action: IAction
) => {
  switch (action.type) {
    case type.DELETE_PRODUCTION_PROCESS:
      return {
        ...state,
        loading: true,
      };
    case type.DELETE_PRODUCTION_PROCESS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData,
      };
    case type.DELETE_PRODUCTION_PROCESS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};
